<template>
  <ul :class="containerClass">
    <li v-if="pageCount > 1" :class="{ disabled: currentPage <= 1 }">
      <a href="#" @click.prevent="selectPage(currentPage - 1)">{{ prevText }}</a>
    </li>

    <li
      v-for="pageNumber in pageNumbers"
      :key="pageNumber"
      :class="{ active: pageNumber === currentPage }"
    >
      <a href="#" @click.prevent="selectPage(pageNumber)">{{ pageNumber }}</a>
    </li>

    <li v-if="pageCount > 1" :class="{ disabled: currentPage >= pageCount }">
      <a href="#" @click.prevent="selectPage(currentPage + 1)">{{ nextText }}</a>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    pageCount: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    clickHandler: {
      type: Function,
      required: true,
    },
    prevText: {
      type: String,
      default: "Prev",
    },
    nextText: {
      type: String,
      default: "Next",
    },
    containerClass: {
      type: String,
      default: "pagination",
    },
  },
  computed: {
    pageNumbers() {
      return Array.from({ length: this.pageCount }, (_, index) => index + 1)
    },
  },
  methods: {
    selectPage(pageNumber) {
      if (pageNumber < 1 || pageNumber > this.pageCount || pageNumber === this.currentPage) {
        return
      }

      this.clickHandler(pageNumber)
    },
  },
}
</script>
